"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const encoding_1 = require("@iov/encoding");
const bn_js_1 = __importDefault(require("bn.js"));
const abi_1 = require("./abi");
/** Class to query read-only information from an ERC20 contract. */
class Erc20Reader {
    constructor(client, options) {
        this.client = client;
        this.options = options;
    }
    async totalSupply() {
        const data = abi_1.Abi.calculateMethodId("totalSupply()");
        const result = await this.client.ethCall(this.options.contractAddress, data);
        return new bn_js_1.default(result);
    }
    async balanceOf(address) {
        const methodId = abi_1.Abi.calculateMethodId("balanceOf(address)");
        const data = new Uint8Array([...methodId, ...abi_1.Abi.encodeAddress(address)]);
        const result = await this.client.ethCall(this.options.contractAddress, data);
        return new bn_js_1.default(result);
    }
    /**
     * Returns symbol value from options or from chain.
     *
     * On-chain values will be cached internally, i.e. it is cheap to use this getter
     * as long as the class instance is long living.
     */
    async name() {
        if (this.options.name) {
            return this.options.name;
        }
        else {
            // TODO: cache this call
            const data = abi_1.Abi.calculateMethodId("name()");
            const result = await this.client.ethCall(this.options.contractAddress, data);
            const [nameBinary] = abi_1.Abi.decodeHeadTail(result).tail;
            return encoding_1.fromUtf8(abi_1.Abi.decodeVariableLength(nameBinary));
        }
    }
    /**
     * Returns symbol value from options or from chain.
     *
     * On-chain values will be cached internally, i.e. it is cheap to use this getter
     * as long as the class instance is long living.
     */
    async symbol() {
        if (this.options.symbol) {
            return this.options.symbol;
        }
        else {
            // TODO: cache this call
            const data = abi_1.Abi.calculateMethodId("symbol()");
            const result = await this.client.ethCall(this.options.contractAddress, data);
            const [symbolBinary] = abi_1.Abi.decodeHeadTail(result).tail;
            return encoding_1.fromUtf8(abi_1.Abi.decodeVariableLength(symbolBinary));
        }
    }
    /**
     * Returns decimals value from options or from chain.
     *
     * On-chain values will be cached internally, i.e. it is cheap to use this getter
     * as long as the class instance is long living.
     */
    async decimals() {
        if (this.options.decimals) {
            return this.options.decimals;
        }
        else {
            // TODO: cache this call
            const data = abi_1.Abi.calculateMethodId("decimals()");
            const result = await this.client.ethCall(this.options.contractAddress, data);
            return new bn_js_1.default(result).toNumber();
        }
    }
}
exports.Erc20Reader = Erc20Reader;
//# sourceMappingURL=erc20reader.js.map